import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FALLBACK = { coaching_price: 497, coaching_seats: 5, coaching_intro: "", enrollment_open: true, seats_left: 5, seats_taken: 0 };

export const useSiteSettings = () => {
  const [s, setS] = useState(FALLBACK);
  useEffect(() => {
    api.get("/settings").then((r) => setS({ ...FALLBACK, ...(r.data || {}) })).catch(() => {});
  }, []);
  return s;
};

export const eur = (n) => Number(n).toLocaleString("it-IT", { maximumFractionDigits: 2 });
